import ApplicationController from './application_controller';

/* global $ */
export default class extends ApplicationController {
  connect() {
    const { cuadernoId } = this.element.dataset;

    $.post(
      `/cuadernos/${cuadernoId}/tareas/horarios`,
      (arrayTimetable) => {
        const dias = arrayTimetable.map((horario) => horario.dia);
        $('.input-group.date.with_horarios')
          .datepicker({
            startDate: new Date(),
            todayBtn: 'linked',
            language: 'es',
            todayHighlight: true,
            autoclose: true,
            beforeShowDay(date) {
              const today = new Date();
              if ($.inArray(date.getDay(), dias) !== -1 && date > today) {
                return {
                  classes: 'available-dates',
                };
              }
              return {};
            },
          })
          .on('changeDate', (ev) => {
            const timetable = arrayTimetable.filter((horario) => (
              horario.dia === ev.date.getDay()
                && new Date(horario.fecha_fin).getTime() >= ev.date.getTime()
            ));
            const last = [...timetable].pop();
            if (last) {
              $('#tarea_hora').val(last.hora_inicio);
            } else {
              $('#tarea_hora').val('');
            }
          });
      },
    );
  }
}
